import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { AppActionsEnum, SetLocationData } from '../actions';
import { GeoLocationData } from '../models/geo-location-data.model';

export interface IAppState {
  initialized: boolean;
  isLoadingGeoLocation: boolean;
  geoLocation: GeoLocationData;
}

export const APP = 'app';

// initial state
export const initialAppState: IAppState = {
  initialized: false,
  isLoadingGeoLocation: false,
  geoLocation: null,
};

// reducer
const reducerFn = handleActions(
  {
    [AppActionsEnum.INIT_APP]: function (state: IAppState): IAppState {
      return {
        ...state,
        initialized: true,
      };
    },
    [AppActionsEnum.FETCH_LOCATION_DATA]: function (state: IAppState) {
      return {
        ...state,
        isLoadingGeoLocation: true,
      };
    },
    [AppActionsEnum.FETCH_LOCATION_DATA_ERROR]: function (state: IAppState) {
      return {
        ...state,
        isLoadingGeoLocation: false,
      };
    },
    [AppActionsEnum.SET_LOCATION_DATA]: function (
      state: IAppState,
      { payload }: SetLocationData
    ) {
      return {
        ...state,
        geoLocation: payload.location,
        isLoadingGeoLocation: false,
      };
    },
  } as any,
  initialAppState
);

export function appReducer(state: IAppState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IAppState>(APP);

export const isInitialized = createSelector(
  selectFeature,
  (state: IAppState) => state.initialized
);

export const getGeoLocation = createSelector(
  selectFeature,
  (state: IAppState) => state.geoLocation
);

export const isLoadingGeoLocation = createSelector(
  selectFeature,
  (state: IAppState) => state.isLoadingGeoLocation
);
